export const BANNER_TITLE = 'You have unsaved changes';

export const DESCRIPTION = (
  <>
    You have unsaved changes that will be lost if you close this modal. <br /> Are you sure you want to{' '}
    <strong className="font-bold">discard your changes</strong>?
  </>
);
